export default "__VITE_ASSET__efb682dd__"